import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    convertUniversalDateTimeToPersianDateTime, dataURLtoFile,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoConfirmDialog, RaikoCreatorInfo,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput,
    RaikoSectionContainer,
    RaikoSimpleMultiLineInputOutlined, showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import UploadPhoto from "../../component/UploadPhoto/UploadPhoto";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ChartsService} from "../../serverService/charts/ChartsService";
import {stringIsEmpty} from "../../util/VariableChecker";
import UploadThumbnail from "../../component/uploadThumbnail/UploadThumbnail";

export default function SiteChartsDetail() {

    const navigate = useNavigate()

    const {id: chartId = -1} = useParams()
    const {state} = useLocation()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.MagazineChartDetail.name);
    const loading = new LoadingHelper(useLoadingDispatcher())

    const service = new ChartsService()

    const [photoFile, setPhotoFile] = useState(null);
    const [photoUrl, setPhotoUrl] = useState([]);
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [photoId, setPhotoId] = useState(-1);

    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    useEffect(() => {
        getDataFromServer()
    }, []);

    function getDataFromServer() {

        loading.show()
        service.getChartDetail(chartId)
            .then(response => {
                setName(response.title)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.postedAt))
                setCreatedBy(response.postedBy)
                setDescription(response.description)

                if (response.chartPhoto) {
                    setPhotoId(response.chartPhoto.id)
                    setPhotoUrl([response.chartPhoto.url])
                }
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const [openDialog, setOpenDialog] = useState(false)

    const closeDeleteDialog = () => setOpenDialog(false)
    const openDeleteDialog = () => setOpenDialog(true)


    function handleUpdateInfo() {
        if (checkFields()) {
            loading.show()
            service.updateChartInfo(
                chartId,
                name,
                description,
                photoId,
                photoFile,
                true
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }


    function checkFields() {
        let state = false
        let message

        if (stringIsEmpty(name))
            message = "لطفا عنوان نمودار را وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }

    function handleDeleteSlider() {
        loading.show()
        service.updateChartInfo(
            chartId,
            name,
            description,
            photoId,
            null ,
            false
        ).then(response => {
            showSuccessMessage("حذف نمودار با موفقیت انجام شد.")
            closeDeleteDialog()
            navigate(
                RouteHelper.MagazineCharts.globalUrl,
                {replace: true}
            )
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const handleSelectImage = (imgSrc, fileName) => {
        const imageFile = dataURLtoFile(imgSrc, fileName)
        setPhotoUrl(imgSrc)
        setPhotoFile(imageFile)
    }

    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.MagazineSliderDetail.name}</title>
            </Helmet>

            <RaikoConfirmDialog
                cancelAction={closeDeleteDialog}
                openConfirmDialog={openDialog}
                doAction={handleDeleteSlider}
                pageTitle={"حذف نمودار"}
                warningTitle={"آیا از حذف نمودار اطمینان دارید؟"}
            />


            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.MagazineCharts.name,
                                    RouteHelper.MagazineCharts.globalUrl),
                                raikoBreadCrumbItemGenerator(
                                    pageTitle,
                                    ""),
                            ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>
                    </RaikoFlexFirstChildGrowOne>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"اطلاعات پایه"}
                            actionButtonOnclick={handleUpdateInfo}
                            actionButtonTitle={"بروزرسانی"}
                            hasActionButton
                            hasSecondaryButton
                            secondaryButtonTitle={"حذف نمودار"}
                            secondaryButtonOnClick={openDeleteDialog}
                        >
                            <RaikoGridOneColumn>
                                <RaikoGridOneColumn>
                                    <RaikoSectionContainer
                                        title={"تصویر شاخص"}
                                    >
                                        <UploadThumbnail
                                            avatarFile={photoUrl}
                                            updateAvatar={handleSelectImage}
                                            loading={false}
                                            aspectRatio={120 / 63}
                                        />
                                    </RaikoSectionContainer>
                                    <RaikoMaterialOutlinedInput
                                        labelText={"عنوان"}
                                        value={name}
                                        setValue={setName}
                                    />
                                    <RaikoSimpleMultiLineInputOutlined
                                        labelText={"توضیحات"}
                                        value={description}
                                        setValue={setDescription}
                                    />
                                </RaikoGridOneColumn>
                            </RaikoGridOneColumn>

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>


                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}
